// src/state/slice/saveProgressSlice.js
import {createSlice} from '@reduxjs/toolkit';

const saveProgressSlice = createSlice({
  name: 'saveProgress',
  initialState: {
    isFormDirty: false,
    loanDetailsClicked: false,
    showModal: false,
    futureRoute: '',
    futureTab: '',
    futureAccordianContainerValue: '',
    accordianContainerBypass: false,
  },
  reducers: {
    setFormDirty: (state, action) => {
      state.isFormDirty = action.payload;
    },
    setLoanDetailsClicked: (state, action) => {
      state.loanDetailsClicked = action.payload;
    },
    setShowModal: (state, action) => {
      state.showModal = action.payload;
    },
    setFutureRoute: (state, action) => {
      state.futureRoute = action.payload;
    },
    setFutureTab: (state, action) => {
      state.futureTab = action.payload;
    },
    setFutureAccordianValue: (state, action) => {
      state.futureAccordianContainerValue = action.payload;
    },
    setAccordianContainerBypass: (state, action) => {
      state.accordianContainerBypass = action.payload;
    },
    resetSaveProgress: state => {
      state.isFormDirty = false;
      state.loanDetailsClicked = false;
      state.showModal = false;
      state.futureRoute = '';
      state.futureTab = '';
      state.futureAccordianContainerValue = '';
      state.accordianContainerBypass = false;
    },
  },
});

export const {
  setFormDirty,
  setLoanDetailsClicked,
  setShowModal,
  setFutureRoute,
  setFutureTab,
  setFutureAccordianValue,
  setAccordianContainerBypass,
  resetSaveProgress,
} = saveProgressSlice.actions;

export default saveProgressSlice.reducer;
